import { render, staticRenderFns } from "./save-event-modal.vue?vue&type=template&id=6363d134&scoped=true"
import script from "./save-event-modal.vue?vue&type=script&lang=js"
export * from "./save-event-modal.vue?vue&type=script&lang=js"
import style0 from "./save-event-modal.vue?vue&type=style&index=0&id=6363d134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6363d134",
  null
  
)

export default component.exports